export default __webpack_public_path__ + "static/media/quickstart-luxury.6b65db75.png";